import bookmarkIcon from "@public/img/bookmark.svg";
import bookmarkOnIcon from "@public/img/bookmark-on.svg";
import React, { useContext, useState } from "react";
import { videoService } from "@/services/video-service";
import { AppContextType, WonmovContext } from "@/context/app-context";

export default function BookmarkButton({
    movieId,
    isBookmarkedDefault,
    className,
}: {
    movieId: number;
    isBookmarkedDefault: boolean;
    className?: string;
}) {
    const {isLoggedIn} = useContext<AppContextType>(WonmovContext);
    const [isBookmarked, setIsBookmarked] = useState(isBookmarkedDefault);
    const [isLoading, setIsLoading] = useState(false);

    const handleBookmarkClick = async () => {
        if (isLoading) return;
        setIsLoading(true);
        const response = await videoService.updateFavoriteStatus(movieId);
        setIsLoading(false);
        if (response.status) {
            setIsBookmarked(!isBookmarked);
        }
    }

    if (!isLoggedIn) {
        return <></>
    }

    var btnClass = className ? className : "size-9 rounded-sm bg-lime-400 p-1 cursor-pointer";

    return (
        <>
            {isLoading ? (
                <div className={btnClass + " flex justify-center items-center"}>
                    <div className="loader" />
                </div>
            ) : (
                <img
                    src={isBookmarked ? bookmarkOnIcon : bookmarkIcon}
                    alt="ذخیره فیلم"
                    className={btnClass}
                    onClick={handleBookmarkClick}
                />
            )}
        </>
    )
}